import React, { useEffect, Suspense } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../RoomContext';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingView from './Loader/LoadingView';
import { LazyPreload } from './Loader/LazyPreload';
import LoginDialog from './SecondDoor/Host/LoginDialog';

// Mui core
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

const Room = LazyPreload(() => import(/* webpackChunkName: "room" */ './Room'));

const styles = () =>
	({
		loading :
		{
			width           : '100vw',
			height          : '100vh',
			zIndex          : 9999999,
			position        : 'fixed',
			top             : 0,
			left            : 0,
			display         : 'flex',
			justifyContent  : 'center',
			alignItems      : 'center',
			backgroundColor : 'rgba(255, 255, 255, 0.5)'
		}
	});

const App = (props) =>
{
	const {
		classes,
		roomClient,
		user,
		isLoading
	} = props;

	useEffect(() =>
	{
		Room.preload();

		return;
	}, [ roomClient ]);

	if (window.location.pathname === '/host')
	{
		roomClient.setIsHost(true);
	}

	if (roomClient.isHost())
	{
		if (!user)
		{
			return (
				<>
					<LoginDialog />
					{ isLoading &&
						<Box className={classes.loading}>
							<CircularProgress />
						</Box>
					}
				</>
			);
		}
		else
		{
			return (
				<Suspense fallback={<LoadingView />}>
					<Room roomClient={roomClient}/>
					{ isLoading &&
						<Box className={classes.loading}>
							<CircularProgress />
						</Box>
					}
				</Suspense>
			);
		}
	}
	else
	{
		return (
			<Suspense fallback={<LoadingView />}>
				<Room roomClient={roomClient}/>
				{ isLoading &&
					<Box className={classes.loading}>
						<CircularProgress />
					</Box>
				}
			</Suspense>
		);
	}
};

App.propTypes =
{
	classes    : PropTypes.object.isRequired,
	roomClient : PropTypes.any.isRequired,
	user       : PropTypes.object,
	isLoading  : PropTypes.bool.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		user      : state.me.user,
		isLoading : state.room.isLoading
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.isLoading === next.room.isLoading &&
				prev.me.user === next.me.user &&
				prev.roomClient === next.roomClient
			);
		}
	}
)(withStyles(styles)(App)));